import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import useCostingExists from "../../../services/trips/useCostingExists";

const AttachCostingValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  const extraKeys = [record.costingNumber];
  const costing = useCostingExists({extraKeys});

  if (!error && !record.costingNumber ) {
    error = true;
    errorMessage = "'Costing Number' is required";
    id = "costingNumber";
  }

  if (!error && (!costing || !costing.data)) {
    error = true;
    errorMessage = "'Costing Number' was not found, please enter a valid costing number.";
    id = "costingNumber";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default AttachCostingValidator;
